<template>
    <div class="btn-user p-2 text-2xl inline relative">
        <template v-if="isLoggedIn">
            <span @click="openOptions = !openOptions" cclick="logout" class="cursor-pointer">
                <span class="icon-chevron-down text-base mr-2"></span>
                 <span class="icon-user" ></span>
            </span>
        </template>
        <template v-else>
            <span @click="toggleAuthModal" class="cursor-pointer">
                <span v-if="window.innerWidth > 1023" class="text-sm md:text-base mr-2 whitespace-nowrap">Se connecter</span>
                <span class="icon-user" ></span>
            </span>
        </template>
        <!-- First version -->
        <!-- <template v-else>
            <span class="icon-user" @click="toggleLogin"></span>
        </template> -->


        <template v-if="openOptions">
        <div class="bg-gray-100 text-gray-500 absolute top-full right-0 p-0 rounded-lg text-base z-10">
            <ul class="w-[220px] h-auto flex flex-col justify-content-center items-center">
                <li class="whitespace-nowrap flex justify-between items-center gap-3 uppercase cursor-pointer h-[60px] w-full px-4" @click="toggleMyAccount()">
                    <span class="text-[14px] font-normal">adresses de livraison</span>
                    <span class="text-[28px] icon-map-marker-alt"></span>
                </li>
                <li class="whitespace-nowrap flex justify-between items-center gap-3 uppercase  cursor-pointer h-[60px] w-full  px-4" @click="logout()">
                    <span class="text-[14px]">déconnexion</span>
                    <span class="text-[28px] icon-sign-out"></span>
                </li>
            </ul>
        </div>
        </template>
    </div>
</template>

<script>
    import Autentification from '@/services/Autentification';
    export default {
        name: 'BtnUser',
        data(){
          return {
              openOptions: false
          }
        },
        computed: {
            isLoggedIn: function () {
                var api_token = this.$store.state.api_token;
                var persist_login = this.$store.state.persist_login;

                return api_token !== 'null' && api_token !== null && api_token !== '';
                // return !!api_token;
            }
        },
        methods: {
            toggleLogin: function () {
                console.log('btnUser | toggleLogin');
                $eventbus.$emit('toggle:login');
                this.openOptions = false;
            },
            toggleAuthModal() {
                
                //this.trackEvent("Menu:LoginShow", {});
                //this.trackEvent("cta_click:LoginShow",  {});
                
                $eventbus.$emit('toggle:modal');
                $eventbus.$emit('close-menu');
                this.openOptions = false;
            },
            toggleMyAccount(){
                //this.trackEvent("Menu:Adresses", {});
                this.trackEvent("cta_click:Adresses",  {});

                // $eventbus.$emit('open:my-account');
                $eventbus.$emit('toggle:my-account');
                this.openOptions = false;
            },
            //
            logout: function () {
                const self = this;

                this.openOptions = false;

                //this.trackEvent("Menu:Logout", {});
                this.trackEvent("cta_click:Logout",  {});

                console.log('logout | api_token : ', self.$store.state.api_token);

                Autentification.logout({
                    api_token: self.$store.state.api_token
                })
                    .then(function () {

                        window.localStorage.removeItem('api_token');
                        self.$store.commit('setApiToken', null);
                        self.$store.commit('setPersistLogin', false);
                        self.$store.commit('setFirstCall', true);

                        let sto = setTimeout(function(){
                            clearTimeout(sto);

                            if(window.parent && window.parent.MainFrame){
                                let MainFrame = window.parent.MainFrame;
                                let mailSentTrigger = 'mailSentFromForm';

                                MainFrame.EprintShop.saveItem("api_token", null);
                                MainFrame.Manager.Variables.register("api_token", "0");

                                MainFrame.Manager.Variables.register("loggedOut", "1");
                                MainFrame.EventHandler.dispatch("userNotLoggedIn");

                                // MainFrame.EventHandler.dispatch(mailSentTrigger);
                                // MainFrame.EventHandler.dispatch('mailSentFromForm');
                                MainFrame.EventHandler.dispatch('closeLogin');
                                MainFrame.EventHandler.dispatch('loginSuccess');
                            }
                        },1000);


                    })
                    .catch(function () {})
                    .then(function () {
                        self.$forceUpdate();
                    });
            }
        },
        mounted() {}
    };
</script>

<style scoped lang="scss"></style>
